import { useSpring, animated } from '@react-spring/web'
import cn from 'clsx'
import * as React from 'react'

import { config, type IconProps } from '#app/components/icon'

const PackageOpen: React.FC<IconProps> = (props) => {
	const { animate = false, className, width, height } = props

	const [style, api] = useSpring(() => ({
		from: {
			x: 0,
			y: 0,
			rotate: 0,
		},
		config: {
			duration: 400,
		},
	}))

	React.useEffect(() => {
		if (animate) {
			Promise.all(
				api.start({
					to: [
						{
							x: 0,
							y: -30,
							rotate: 0,
						},
						{
							x: 0,
							y: 0,
							rotate: 0,
						},
						{
							x: 0,
							y: 0,
							rotate: 30,
						},
						{
							x: 0,
							y: 0,
							rotate: -30,
						},
						{
							x: 0,
							y: 0,
							rotate: 10,
						},
						{
							x: 0,
							y: 0,
							rotate: -10,
						},
						{
							x: 0,
							y: 0,
							rotate: 0,
						},
					],
				}),
			).catch(console.error)
		}
	}, [animate, api])

	return (
		<animated.span style={style}>
			<svg
				id="Ebene_1"
				data-name="Ebene 1"
				viewBox="0 0 425.2 425.2"
				className={className}
				width={width || config.width}
				height={height || config.height}
			>
				<path //right wing
					d="M220.22 154.47L347.2 120.07 390.09 169.76 263.54 204.58 220.22 154.47z"
					className={cn('transition duration-300 ease-in-out', {
						'fill-accent-6': animate,
					})}
				/>
				<path // right side
					d="M343.03 191.03L343.03 292.71 214.35 328.71 214.35 159.06 259.69 214.03 343.03 191.03z"
				/>
				<path // top
					d="M337.34 113.9L210.55 148.26 83.75 113.9 210.06 79.54 210.55 79.39 211.03 79.54 337.34 113.9z"
				/>
				<path // left wing
					d="M199.59 154.47L72.61 120.07 29.72 169.76 156.28 204.58 199.59 154.47z"
					className={cn('transition duration-300 ease-in-out', {
						'fill-accent-6': animate,
					})}
				/>
				<path // right side
					d="M205.47 159.06L205.47 328.71 76.78 292.71 76.78 191.03 160.13 214.03 205.47 159.06z"
				/>
			</svg>
		</animated.span>
	)
}

export { PackageOpen }
